import { render, staticRenderFns } from "./BtSendgridEmail.vue?vue&type=template&id=3f3c1c36&scoped=true&"
import script from "./BtSendgridEmail.vue?vue&type=script&lang=js&"
export * from "./BtSendgridEmail.vue?vue&type=script&lang=js&"
import style0 from "./BtSendgridEmail.vue?vue&type=style&index=0&id=3f3c1c36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3c1c36",
  null
  
)

export default component.exports